import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    evaluationCounts: (ratingCount, commentCount) =>
        __x('{ratingCount} evalueringer, {commentCount} kommentarer', { ratingCount, commentCount }),
    tooFewRatingsText: () =>
        __('Denne virksomhed har færre end 3 evalueringer, og dermed ikke nok til, at deres evalueringer bliver vist'),
    ratingsDeactivatedText: () =>
        __('Evalueringerne for denne virksomhed er blevet deaktiverede. Du kan dog stadig afgive din evaluering, som vil blive gemt. Hvis evalueringerne vises på et senere tidspunkt, vil din evaluering også blive synlig'),
    ratingTermsLinkText: () =>
        __('Læs mere om vores betingelser her'),
    ratingsLoginWallTitle: () =>
        __('Hvad siger medarbejderne?'),
    ratingsLoginWallDescription: () =>
        __('Log ind for at se detaljerede evalueringer og medarbejdernes udtalelser.'),
    ratingsLoginWallLoginButton: () =>
        __('Log ind'),
    writeEvaluationHeader: () =>
        __('Har du arbejdet her?'),
    writeEvaluationExplain: (companyname) =>
        __x('Hvis du er eller har været ansat hos denne virksomhed, kan du evaluere den og give andre jobsøgende et indblik i, hvordan det er at arbejde hos virksomheden. Du er anonym overfor de virksomheder du evaluerer.', { companyname }),
    writeEvaluationExplainShort: (companyname) =>
        __x('Skriv en evaluering, hvis du er ansat eller tidligere ansat hos {companyname}.', { companyname }),
    writeEvaluationButton: () =>
        __('Evaluér anonymt her'),
    editEvaluationButton: () =>
        __('Ret din evaluering'),
    commentsHeader: (n) =>
        __nx('{n} kommentar', '{n} kommentarer', n, { n }),
    categoriesHeader: () =>
        __('Kategorier'),
    categoriesExplain: () =>
        __('Evalueringerne i kategorierne optræder separat fra den overordnede score, der er en særskilt kategori.'),
    seeCategories: () =>
        __('Se alle evalueringskategorier'),
    categoryName(category) {
        switch (String(category)) {
            case '2':
                return  __('Ledelse');
            case '5':
                return  __('Arbejdsmiljø og balance');
            case '4':
                return  __('Karrieremuligheder');
            case '7':
                return  __('Belønning');
            case '3':
                return  __('Kultur og mening');
            case '6':
                return  __('Samarbejde og relationer');
        }
    },
    categoryTooltip(category) {
        switch (String(category)) {
            case '2':
                return  __('Vurdering af øverste og nærmeste ledelse samt ledelsens troværdighed.');
            case '5':
                return  __('Vurdering af arbejdsmiljøet samt oplevet work-life balance.');
            case '4':
                return  __('Vurdering af mulighederne for at avancere og dygtiggøre dig i din karriere.');
            case '7':
                return  __('Vurdering af, om du bliver belønnet og anerkendt for dit arbejde.');
            case '3':
                return  __('Vurdering af kultur og værdier, samt om du oplever mening i dit arbejde.');
            case '6':
                return  __('Vurdering af samarbejdet med kolleger samt fællesskabsfølelsen.');
            case '0':
                return  __('Samlet vurdering af arbejdspladsen.');
        }
    },

};
